import { useState, useEffect } from 'react'
import { supabase } from './supabaseClient'

export function useSubscription(trustId) {
  const [subscription, setSubscription] = useState(null)
  const [loading, setLoading] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const [isTrialing, setIsTrialing] = useState(false)

  useEffect(() => {
    if (!trustId) {
      setLoading(false)
      return
    }
    fetchSubscription()
  }, [trustId])

  const fetchSubscription = async () => {
    setLoading(true)

    const { data: { user } } = await supabase.auth.getUser()
    if (!user) { setLoading(false); return }

    const { data } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('user_id', user.id)
      .eq('trust_id', trustId)
      .maybeSingle()

    setSubscription(data)

    if (data && data.status === 'active') {
      setIsActive(true)
    } else {
      const { data: trust } = await supabase
        .from('trusts')
        .select('created_at')
        .eq('id', trustId)
        .single()

      if (trust) {
        const daysDiff = (new Date() - new Date(trust.created_at)) / (1000 * 60 * 60 * 24)
        setIsTrialing(daysDiff <= 14)
        setIsActive(daysDiff <= 14)
      }
    }

    setLoading(false)
  }

  return { subscription, loading, isActive, isTrialing }
}